import { computed, Ref, ref } from 'vue'
import { defineStore } from 'pinia'
import { track, Events } from '@outputinc/o-analytics'
import gtmClient from '@/utils/gtmClient'
import { Modal } from '@/types'
import resolveHostname from '@/composables/resolveHostname'

export const useModalStore = defineStore('ModalStore', () => {
  const modal: Ref<Modal> = ref({
    body: '',
    footer: '',
    title: '',
    isManagedContent: false,
    show: false,
    modalName: ''
  })

  const isShowModal = computed(() => modal.value.show)

  const set = (newModal: Modal) => {
    modal.value = {
      ...newModal,
      show: true
    }
  }

  const setManagedContent = () => {
    modal.value.isManagedContent = true
  }

  const trigger = (data: any) => {
    if (!data && !data.error) {
      return
    }

    if (data.error) {
      const { title, message: body, footer, id } = data.error
      set({ title, body, footer })
      gtmClient.track(gtmClient.Events.CHECKOUT_SUBSCRIPTION_FAILURE, {
        arcadeCheckoutFailure: title
      })
      track(Events.CHECKOUT_SUBSCRIPTION_FAILURE, {
        title,
        id
      })
      return
    }

    const { title, image, body, ctaText, ctaLink, modalName, linkHostname } = data

    track(Events.CHECKOUT_SUBSCRIPTION_MODAL_VIEWED, { modal: modalName })

    const hostname = resolveHostname(linkHostname)

    set({ title, image, body, ctaText, ctaLink, modalName, hostname })
    setManagedContent()
  }

  const toggleDisplay = () => {
    const show = modal.value.show
    modal.value.show = !show
  }

  const modalName = computed(() => modal.value.modalName)
  const ctaUrl = computed(() => `${modal.value.hostname}${modal.value.ctaLink?.url}`)

  return {
    isShowModal,
    modal,
    modalName,
    ctaUrl,
    toggleDisplay,
    trigger
  }
})
